import React from 'react';
import "./QuickLinks.css"

import newtabIcon from "../../../../../assets/images/newtabIcon.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const QuickLinks = (props) => {
    const { icon, text, classNameStyle, showOpenInNewTabIcon=false, link, click } = props;
    const history = useHistory();

     const handleClick = (e) => {
        e.preventDefault();
        if (click) {
            click();
        } else {
            if (showOpenInNewTabIcon) {
                window.open(link, '_blank', 'noopener,noreferrer');
            } else {                
                if (link.startsWith('http')) {
                    window.location.href = link;
                } else {
                    history.push(link);
                }
            }
        }
    };

    return (
        <div className={`quickLinkContainer ${classNameStyle}`}>
            <a
                href={link}
                onClick={handleClick}
                target={showOpenInNewTabIcon ? '_blank' : undefined}
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
            >
                <div className="icon-title-container">
                    <span className="image-background">
                        <img src={icon} alt="icon-placeholder" />
                    </span>
                    <span>{text}</span>
                </div>
                {showOpenInNewTabIcon && (
                    <div>
                        <img src={newtabIcon} alt="Open in new tab" />
                    </div>
                )}
            </a>
        </div>        
    );
}

export default QuickLinks;